<ng-template transloco let-t>
  <div class="braze-cards">
    @for (card of notificationCards(); track $index) {
      <app-notification-card
        [id]="card.id"
        [description]="card.description"
        [title]="card.title"
        [linkText]="card.linkText"
        [linkUrl]="card.linkUrl"
        [imageUrl]="card.imageUrl"
        [cardType]="card.cardType"
      ></app-notification-card>
    }
  </div>
</ng-template>
